import styled from 'styled-components'
import {Link} from '@modifi/router'
import {airBlue, darkGray} from '@modifi/colors'

export const OptionLabelCompanyName = styled.div`
  margin-right: 8px;
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${darkGray};
`

export const StyledLink = styled(Link)`
  color: ${airBlue};
  text-decoration: none;
  font-size: 14px;
  letter-spacing: 0.02em;
  display: inline-flex;
  justify-content: center;
  text-align: center;
  transition: background-color 0.15s ease-out, box-shadow 0.15s ease-out, color 0.15s ease-out;

  &:hover,
  &:focus {
    box-shadow: none;
  }
`

export const CheckBoxWrapper = styled.div`
  label {
    pointer-events: none;
    cursor: auto;
    align-items: start;
    width: 100%;

    > div {
      width: 100%;
    }
  }

  i {
    pointer-events: auto;
    cursor: pointer;
  }
`
